import { createReducer, on, Action } from '@ngrx/store';
import { EntityState, createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import * as CompanyAddressActions from '../_actions/companyAddress';
import { CompanyAddress } from '../_models';

export interface CompanyAddressState extends EntityState<CompanyAddress> {
  loading: boolean;
  error: any;
}

export const adapter: EntityAdapter<CompanyAddress> = createEntityAdapter<CompanyAddress>();

const initialState: CompanyAddressState = adapter.getInitialState({
  loading: false,
  error: null,
});

const companyAddressReducer = createReducer(
  initialState,

  on(CompanyAddressActions.loadCompanyAddresses, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(CompanyAddressActions.loadCompanyAddressesSuccess, (state, { companyAddresses }) =>
    adapter.setAll(companyAddresses, { ...state, loading: false })
  ),

  on(CompanyAddressActions.loadCompanyAddressesFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(CompanyAddressActions.addCompanyAddressSuccess, (state, { companyAddress }) =>
    adapter.addOne(companyAddress, state)
  ),

  on(CompanyAddressActions.updateCompanyAddressSuccess, (state, { companyAddress }) =>
    adapter.upsertOne(companyAddress, state)
  ),

  on(CompanyAddressActions.deleteCompanyAddressSuccess, (state, { id }) =>
    adapter.removeOne(id, state)
  ),

  on(
    CompanyAddressActions.addCompanyAddressFailure,
    CompanyAddressActions.updateCompanyAddressFailure,
    CompanyAddressActions.deleteCompanyAddressFailure,
    (state, { error }) => ({
      ...state,
      error,
    })
  )
);

export function reducer(state: CompanyAddressState | undefined, action: Action) {
  return companyAddressReducer(state, action);
}

export const { selectAll, selectEntities, selectTotal } = adapter.getSelectors();
